import { render, staticRenderFns } from "./Thinking.vue?vue&type=template&id=add87bbe&scoped=true"
import script from "./Thinking.vue?vue&type=script&lang=js"
export * from "./Thinking.vue?vue&type=script&lang=js"
import style0 from "./Thinking.vue?vue&type=style&index=0&id=add87bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add87bbe",
  null
  
)

export default component.exports